(function ($) {
    if ($('.page-template-template-contacts').length) {
        var map, mapCenter, mapMarkers = [], defaultZoomLevel = 16, defaultIconScale = 1,
            scaledIconSize;
        if (window.matchMedia("(max-width: 730px)").matches) {
            if ($('.page-template-template-contacts').length) {
                defaultZoomLevel = 16;
                defaultIconScale = 0.65
                scaledIconSize = new google.maps.Size(21.45, 27.3)
            }
        }

        function centerMap() {
            map.setCenter(mapCenter);
        }

        function map() {
            function initialize() {
                mapCenter = new google.maps.LatLng(mapMarkerPosition[0], mapMarkerPosition[1]);
                var mapOptions = {
                    zoom: defaultZoomLevel,
                    maxZoom: 16,
                    disableDefaultUI: true,
                    styles: [
                        {
                            featureType: "poi",
                            elementType: "labels",
                            stylers: [
                                {visibility: "off"}
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "color": "#eaf5f3"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "color": "#a1c2e6"
                                }
                            ]
                        }
                    ]
                };
                map = new google.maps.Map(document.getElementById("gmap"), mapOptions);
                initFullscreenControl(map);

                var agrochemaIcon = {
                    path: "M16.5 0C7.40185 0 0 6.8104 0 15.1815C0 25.5703 14.7659 40.8216 15.3946 41.4658C15.9851 42.0709 17.016 42.0698 17.6054 41.4658C18.2341 40.8216 33 25.5703 33 15.1815C32.9998 6.8104 25.5981 0 16.5 0ZM27 15.5C27 21.299 22.299 26 16.5 26C10.701 26 6 21.299 6 15.5C6 9.70101 10.701 5 16.5 5C22.299 5 27 9.70101 27 15.5ZM15.7616 10.2337C16.0421 9.80412 16.3127 9.38979 16.5367 9C16.7207 9.50506 17.135 10.1371 17.5777 10.8124C18.3289 11.9582 19.1618 13.2289 19.0909 14.2162V14.2269C19.0909 14.836 18.8061 15.3893 18.3438 15.791C17.8786 16.1953 17.2358 16.4453 16.5254 16.4453C15.8149 16.4453 15.1721 16.1953 14.707 15.791C14.2474 15.392 13.9599 14.8387 13.9599 14.2322C14.0021 12.9278 14.926 11.5132 15.7616 10.2337ZM18.5778 16.0277C19.074 15.5941 19.3954 15.0089 19.432 14.3572C19.4602 14.3546 19.4912 14.3546 19.525 14.3572H19.5335C20.4505 14.3058 21.4341 14.8322 22.4299 15.3651C23.2892 15.8251 24.1576 16.2898 25 16.3921C24.6056 16.592 24.1919 16.8274 23.7649 17.0704C22.4187 17.8367 20.9406 18.6779 19.5194 18.7143C18.8597 18.7143 18.262 18.4696 17.8279 18.0732C17.4388 17.7194 17.1823 17.2433 17.1343 16.714C17.6897 16.6102 18.1887 16.3655 18.5778 16.0277ZM13.5807 14.3559C13.5955 14.3566 13.6103 14.3572 13.6244 14.3572C13.661 15.0063 13.9796 15.5941 14.4814 16.025C14.8705 16.3655 15.3695 16.6076 15.9277 16.7113C15.8798 17.2407 15.6232 17.7168 15.2342 18.0706C14.8 18.4669 14.1995 18.7116 13.5398 18.7116C11.9184 18.6679 10.1198 17.6095 8.65841 16.7495C8.43006 16.6151 8.20993 16.4856 8 16.3655C8.67179 16.1835 9.42076 15.8281 10.1837 15.466C11.3387 14.9179 12.5257 14.3546 13.5257 14.3546H13.537C13.5511 14.3546 13.5659 14.3552 13.5807 14.3559Z",
                    fillColor: "#017535",
                    fillOpacity: 1,
                    anchor: new google.maps.Point(16.5, 41.92),
                    strokeWeight: 0,
                    scale: defaultIconScale,
                    labelOrigin: new google.maps.Point(95, 20)
                }

                function setMarkers() {
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(mapMarkerPosition[0], mapMarkerPosition[1]),
                        map: map,
                        animation: google.maps.Animation.DROP,
                        icon: agrochemaIcon,
                        label: {
                            color: '#414454',
                            fontWeight: 'bold',
                            text: 'Agrochema',

                        },
                    })
                    mapMarkers.push(marker);
                }

                setMarkers();
                google.maps.event.addDomListener(window, 'resize', centerMap());
                google.maps.event.trigger(map, 'resize');
            }

            function initFullscreenControl(map) {
                const elementToSendFullscreen = map.getDiv().firstChild;
                const fullscreenControl = document.querySelector(".fullscreen-control");
                map.controls[google.maps.ControlPosition.RIGHT_TOP].push(fullscreenControl);

                fullscreenControl.onclick = function () {
                    if (isFullscreen(elementToSendFullscreen)) {
                        exitFullscreen();
                    } else {
                        requestFullscreen(elementToSendFullscreen);
                    }
                };

                document.onwebkitfullscreenchange = document.onmsfullscreenchange = document.onmozfullscreenchange = document.onfullscreenchange = function () {
                    if (isFullscreen(elementToSendFullscreen)) {
                        fullscreenControl.classList.add("is-fullscreen");
                        $(fullscreenControl).text('Å½iÅ«rÄ—ti maÅ¾esnÄ¯ Å¾emÄ—lapio vaizdÄ…');
                    } else {
                        fullscreenControl.classList.remove("is-fullscreen");
                        $(fullscreenControl).text('Å½iÅ«rÄ—ti didesnÄ¯ Å¾emÄ—lapio vaizdÄ…');
                    }
                };
            }

            function isFullscreen(element) {
                return (
                    (document.fullscreenElement ||
                        document.webkitFullscreenElement ||
                        document.mozFullScreenElement ||
                        document.msFullscreenElement) == element
                );
            }

            function requestFullscreen(element) {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullScreen) {
                    element.msRequestFullScreen();
                }
            }

            function exitFullscreen() {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            }

            google.maps.event.addDomListener(window, 'load', initialize)
        }

        map();

        $('.fullscreen').on('click', function () {
            map.requestFullscreen();
        });
    }
})(jQuery);